/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const es_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const de_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const nl_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const fr_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const it_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const pt_br2_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const pt_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

const ja_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Unicode」`)
};

const zh_ci_col_hex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unicode`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_col_hex = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_col_hex(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_col_hex", locale)
	if (locale === "en") return en_ci_col_hex(inputs)
	if (locale === "es") return es_ci_col_hex(inputs)
	if (locale === "de") return de_ci_col_hex(inputs)
	if (locale === "nl") return nl_ci_col_hex(inputs)
	if (locale === "fr") return fr_ci_col_hex(inputs)
	if (locale === "it") return it_ci_col_hex(inputs)
	if (locale === "pt-BR") return pt_br2_ci_col_hex(inputs)
	if (locale === "pt") return pt_ci_col_hex(inputs)
	if (locale === "ja") return ja_ci_col_hex(inputs)
	return zh_ci_col_hex(inputs)
};